import { debounce } from 'lodash';
import { DEBOUNCE_MILLISECONDS } from '../constants';

type Callback = (...args: any[]) => void;

export function useDebounce(callback: Callback): Callback {
  return debounce((args) => callback(args), DEBOUNCE_MILLISECONDS);
}
